import { ReactNode } from 'react';
import styles from './EmptyCardListState.module.scss';
import EmptyCardListIcon from './EmptyCardListIcon';

type EmptyCardListStateProps = {
  testId: string;
  children: ReactNode;
};

const EmptyCardListState = ({ testId, children }: EmptyCardListStateProps) => {
  return (
    <div className={styles.container} data-testid={testId}>
      <div className={styles.header}>
        <EmptyCardListIcon />
      </div>
      <div className={styles.body}>
        <div className={styles.text}>{children}</div>
      </div>
    </div>
  );
};

export default EmptyCardListState;
